import { NumberWithCommaField } from './NumberWithCommaField'
import { withNumberWithCommaField } from './withNumberWithCommaField'

const ConnectedNumberWithCommaField =
  withNumberWithCommaField(NumberWithCommaField)

export { ConnectedNumberWithCommaField as NumberWithCommaField }
